import React, { Component, useEffect, useRef, useState } from "react";

// @ mui icons
import FilterListIcon from "@mui/icons-material/FilterList";
import ImportExportIcon from "@mui/icons-material/ImportExport";

// common components
import Header from "../components/common/MagicPageHeader";
import TableHeader from "../components/common/MagicTableHeader";
import MagicDrawer from "../components/common/MagicDrawer_new";
import Table from "../components/common/MagicTable";
import Stack from "../components/mui/Stack";
import Tabs from "../components/targetAchivment/Tabs";
import TargetAchivmentfilterForm from "../components/targetAchivment/TargetAchivmentfilterForm";
import ApproveDataFilter from "../components/targetAchivment/ApproveDataFilter";
import Button from "../components/mui/Button";
import { useLocation } from "react-router-dom";
import {
  useCenterListQuery,
  useFetchedFunderQuery,
  useUserListQuery,
} from "../store/apis/centerApis";
import { City, State } from "country-state-city";
import {
  useApproveDataMutation,
  useGetTargetAchievementQuery,
  useLazyGetTargetAchievementQuery,
} from "../store/apis/targetApis";
import ImageComponent from "../components/mui/Image";
import DownloadToXlsxFile from "../helper/DownloadToXlsxFile";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { showToast } from "../helper/toaster";
import { table } from "console";
import usePermission from "../helper/usePermission";
import { acl } from "../helper/userAccessConstant";
import { useFetchManageAwardQuery } from "../store/apis/reportsApis";
import { API_BASE_URL } from "../utils/constants";


interface TabCategory {
  id: number;
  name: string;
  targetCount: number;
}

interface IndianCity {
  label: string;
  id: string;
}

type Cities = IndianCity[];

const TargetAchievementContainer: any = (props: any) => {
  const { location } = props;
  // const location = useLocation();
  const selector = useSelector((state: RootState) => state?.user?.filter);

  const moduleData =
    Array.isArray(location?.state?.data?.tabDetails) &&
    location.state.data.tabDetails.length > 0
      ? location.state.data.tabDetails
      : {};

  const { permissions } = usePermission();

  const masterData = permissions[acl.target_achievements.module];
  const [userModuleAccess, setUserModuleAccess] = useState<any>({
    canRead: false,
    canWrite: false,
    canUpdate: false,
    canDelete: false,
  });

  const handleUserData = (permissionData: any, data: string) => {
    const permission = permissionData[data];

    if (permission?.canRead) {
      setUserModuleAccess({
        canRead: permission.canRead || false,
        canWrite: permission.canWrite || false,
        canUpdate: permission.canUpdate || false,
        canDelete: permission.canDelete || false,
      });
    } else {
      console.log(`No read access for ${data}`);
    }
  };

  // Call the function with masterData and finalData

  const [isOpenApproveData, setIsOpenApproveData] = useState<boolean>(false);
  const [isOpenFilterForm, setIsOpenFilterForm] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isLessThen3Value, setIsLessThen3Value] = useState<boolean>(false);
  const [finalData, setFinalData] = useState<any>({});
  const [searchValue, setSearchValue] = useState("");
  const [filter, setFilter] = useState<any>({
    centers: "",
    medals: "",
    state: "",
    city: "",
    regionalManager: "",
    cityManager: "",
    clusterManager: "",
    funder: "",
    region: "",
  });
  const [selectedTab, setSelectedTab] = useState<TabCategory | null>(null);
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [params, setParams] = useState<any>({
    pageNo: "1",
    pageSize: "10",
    targetAchievementTabId: finalData?.tabId || null,
    programMasterId: selector?.selectedProgram?.value || undefined,
    programYearId: selector?.selectedYear?.value || undefined,
    quarterMasterId: selector?.selectedQuarter?.quarterMasterId || undefined,
  });
  const [isApprovedDisabled, setIsApprovedDisabled] = useState<boolean>(false);
  const [cities, setCities] = useState<Cities>([]);

  const {
    handleSubmit: handleEditFormSubmit,
    control: editFormControl,
    formState: editFormState,
    reset: resetEditForm,
  } = useForm({
    defaultValues: {
      remark: "",
    },
  });

  //Api calls
  const { data: regionalDirector = [], isLoading: isLoadingRegionalDirector } =
    useUserListQuery({ roleId: "3" });
  const { data: cityManager = [], isLoading: isLoadingCityManger } =
    useUserListQuery({ roleId: "4" });
  const { data: clusterManager = [], isLoading: isLoadingClusterManager } =
    useUserListQuery({ roleId: "5" });
  const { data: fetchedFunder = [] } = useFetchedFunderQuery();
  const { data: centerListOptions = {} } = useCenterListQuery(
    {
      state: filter.state ? filter?.state?.label : undefined,
      district: filter.city ? filter?.city?.label : undefined,
      region: filter.region ? filter?.region : undefined,
      pageNo: "1",
      pageSize: "10000",
    },
    { refetchOnMountOrArgChange: true }
  );
  const { data: medals } = useFetchManageAwardQuery();

  const {
    data: targetTableData,
    isLoading: isLoadingTargetTableData,
    isFetching: isFetchingTargetTableData,
  } = useGetTargetAchievementQuery(params);

  const [trigger, { data, error, isLoading }] =
    useLazyGetTargetAchievementQuery({});

  const [approveData, { isLoading: isLoadingApproveData }] =
    useApproveDataMutation();

  const indianStates: { label: string; id: string }[] =
    State.getStatesOfCountry("IN")?.map((state: any) => ({
      label: state.name,
      id: state.isoCode,
    })) || [];

  const toggleFilerFormDrawer = () => {
    setIsOpenFilterForm((preState) => !preState);
  };

  const handleApproveDataBtnClick = () => {
    resetEditForm();
    setIsOpenApproveData((preState) => !preState);
  };

  // const cities = Array.from(new Set(centerListOptions?.citySelect || []))?.map(
  //   (c) => ({ label: c, id: c })
  // );

  const handleApproveDataDone = async (data: any) => {
    try {
      const res = await approveData({
        remarks: data?.remarks,
        isApproved: true,
        targetAchievementTabId: finalData?.tabId || null,
        programYearId: selector?.selectedYear?.value || undefined,
        // programTypeId: selector?.selectedProgram?.value || undefined,
        quarterMasterId:
          selector?.selectedQuarter?.quarterMasterId || undefined,
        programMasterId: selector?.selectedProgram?.value || undefined,
      });

      if (res?.data?.success) {
        showToast(
          res?.data?.message || "Data approved successfully!",
          "success"
        );
        setIsApprovedDisabled(true);
        setIsOpenApproveData((preState) => !preState);
      }
    } catch (error) {
      console.error("Error during approve data:", error);
      showToast("Failed to approve data. Please try again.", "error");
    }
  };

  const handleDownload = async () => {
    try {
      const downloadData: any = await trigger({
        pageNo: "1",
        pageSize:
          targetTableData?.tableDataRowCount === 0
            ? 1
            : targetTableData?.tableDataRowCount,
        targetAchievementTabId: finalData?.tabId || null,
        programMasterId: selector?.selectedProgram?.value,
        programYearId: selector?.selectedYear?.value,
        quarterMasterId: selector?.selectedQuarter?.quarterMasterId,
        download: true
      }).unwrap();  
  
      if (downloadData?.filePath) {
        const { filePath, fileName } = downloadData;
        const fullUrl = filePath.startsWith("http") ? filePath : `${API_BASE_URL}/${fileName}`;

        // Fetch the file as a Blob
        const response = await fetch(fullUrl);
        if (!response.ok) throw new Error("Failed to fetch file");
  
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
  
        // Create a download link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName || "downloaded_file.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
  
        showToast("File downloaded successfully!", "success");
      } else {
        throw new Error("Invalid file response");
      }
    } catch (error) {
      console.error("Error during download:", error);
      showToast("Failed to download the file. Please try again.", "error");
    }
  };
  
  // const handleDownload = async () => {
  //   try {
  //     // Fetch data
  //     const downloadData: any = await trigger({
  //       pageNo: "1",
  //       pageSize:
  //         targetTableData?.tableDataRowCount == 0
  //           ? 1
  //           : targetTableData?.tableDataRowCount,
  //       targetAchievementTabId: finalData?.tabId || null,
  //       programMasterId: selector?.selectedProgram?.value,
  //       programYearId: selector?.selectedYear?.value,
  //       quarterMasterId: selector?.selectedQuarter?.quarterMasterId,
  //       download: true
  //     });

  
  //     // // Extract column headers
  //     // const excelHeaders: any = [
  //     //   "Region",
  //     //   "Funder Name",
  //     //   "Center Name",
  //     //   "Project Code",
  //     //   "State",
  //     //   "City",
  //     //   "CityManager Name",
  //     //   "Center Status",
  //     //   ...(finalData?.parameterFields.map(
  //     //     (item: any) => item?.name || "Unknown"
  //     //   ) || []),
  //     // ];
  //     // // Extract column headers
  //     // const headers: any = [
  //     //   "region",
  //     //   "funderName",
  //     //   "centerName",
  //     //   "projectCode",
  //     //   "state",
  //     //   "district",
  //     //   "cityManagerName",
  //     //   "centerStatus",
  //     //   ...(finalData?.parameterFields.map(
  //     //     (item: any) => item?.id || "Unknown"
  //     //   ) || []),
  //     // ];

  //     // // Prepare rows by matching headers
  //     // const rows = downloadData?.data?.tableData?.map((item: any) => {
  //     //   const parameters = item?.parameters || {};
  //     //   // Match each header with its corresponding value in the parameters object
  //     //   return headers.map((header: any) => parameters[header] ?? "-");
  //     // });

  //     // // Combine headers and rows into sheet data
  //     // const sheetData = [excelHeaders, ...rows];

  //     // // Download file
  //     // DownloadToXlsxFile({
  //     //   fileNamePrifix: `${finalData?.tabName} ${new Date().toISOString()}`,
  //     //   sheetData,
  //     // });

  //     showToast("File downloaded successfully!", "success");
  //   } catch (error) {
  //     console.error("Error during download:", error);
  //     showToast("Failed to download the file. Please try again.", "error");
  //   }
  // };

  const handleApplyFilterBtn = (): void => {
    const payload = {
      pageNo: "1",
      pageSize: "10",
      centerId: filter?.centers?.id,
      cityManagerUserId: filter?.cityManager?.id,
      medals: filter?.medals?.id,
      state: filter?.state?.label,
      district: filter?.city?.label,
      regionalManager: filter?.regionalManager?.id,
      clusterManager: filter?.clusterManager?.id,
      funder: filter?.funder?.id,
      region: filter?.region,
      programMasterId: selector?.selectedProgram?.value || undefined,
      programYearId: selector?.selectedYear?.value || undefined,
      quarterMasterId: selector?.selectedQuarter?.quarterMasterId || undefined,
    };
    setParams((pre: any) => ({ ...pre, ...payload }));
    // toggleFilerFormDrawer();
  };

  const handleClearAllFilterBtn = (): void => {
    setFilter({
      centers: "",
      medals: "",
      state: "",
      city: "",
      regionalManager: "",
      cityManager: "",
      clusterManager: "",
      funder: "",
      region: "",
    });
    setParams({
      ...(searchValue && { search: searchValue }),
      pageNo: "1",
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      programMasterId: selector?.selectedProgram?.value || undefined,
      programYearId: selector?.selectedYear?.value || undefined,
      quarterMasterId: selector?.selectedQuarter?.quarterMasterId || undefined,
    });
    // toggleFilerFormDrawer();
  };

  const handleReportSearch = (value: string | number) => {
    const searchValue = value.toString();
    const isLessThan3 = searchValue?.length > 0 && searchValue?.length < 3;
    setIsLessThen3Value(isLessThan3);
    setSearchValue(searchValue);

    // Clear the previous timeout to reset the timer if the user is typing quickly
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Only set params after 1.5 seconds of no new typing
    timeoutRef.current = setTimeout(() => {
      setParams((prevParams: any) => {
        if (searchValue.length >= 3) {
          return {
            ...prevParams,
            search: searchValue,
            pageNo: "1",
            pageSize: "10",
            targetAchievementTabId: finalData?.tabId || null,
          };
        } else if (searchValue.length === 0 && prevParams.search) {
          return {
            ...prevParams,
            search: undefined,
            pageNo: "1",
            pageSize: "10",
            targetAchievementTabId: finalData?.tabId || null,
          };
        }
        return prevParams; // Return unchanged state if conditions are not met
      });
    }, 1500);
  };

  // Pagination Function
  const handlePagination = (event: any, page: number) => {
    setParams((prevParams: any) => ({
      ...prevParams,
      pageNo: page.toString(),
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      ...(searchValue && { search: searchValue }),
    }));
    setCurrentPage(page);
  };

  const formattedData =
    targetTableData?.tableData?.map((item: any, tableIndex: number) => {
      // Extract and transform parameters into the desired format
      const parametersData = Object.entries(item.parameters || {})?.reduce(
        (acc: any, [key, value]: [string, any]) => {
          acc[key] = value === null ? "-" : value; // Map each key-value pair, defaulting to null for missing values
          return acc;
        },
        { id: tableIndex + 1 } // Start with an object containing the id
      );

      return parametersData;
    }) || [];

  // Buttons
  const magicPageHeaderBtn = [
    {
      text: "download",
      variant: "outlined",
      startIcon: (
        <ImageComponent src="/assets/images/icon/download.svg" alt="download" />
      ),
      onClick: handleDownload,
      disabled: formattedData.length === 0,
      loading: isLoading,
      sx: {
        color: "black",
        textTransform: "capitalize",
        border: "1px solid #8D8D8D",
        backgroundColor: "#fff",
        "&:hover": {
          backgroundColor: "#ededed",
        },
        borderRadius: "8px",
      },
    },
    {
      text: "Approve data",
      variant: "contained",
      startIcon: "",
      disabled: targetTableData?.isApproved || formattedData.length === 0,
      onClick: handleApproveDataBtnClick,
      sx: {
        color: "black",
        textTransform: "capitalize",
        border: "1px solid #a18218",
        backgroundColor: "#fff1b7",
        "&:hover": {
          backgroundColor: "#e8d78e",
        },
        padding: "5px 40px",
        fontWeight: "600",
        borderRadius: "8px",
        boxShadow: "none !important",
      },
    },
  ];
  // Header Buttons
  const magicTableHeaderBtn = [
    {
      text: "Add Filters",
      variant: "outlined",
      startIcon: <FilterListIcon />,
      onClick: toggleFilerFormDrawer,
      sx: {
        color: "black",
        textTransform: "capitalize",
        border: "1px solid #a18218",
        backgroundColor: "#fff1b7",
        "&:hover": {
          backgroundColor: "#e8d78e",
        },
        borderRadius: "8px",
      },
    },
  ];

  const coloumGenerator = (data: any) => {
    if (!Array.isArray(data)) {
      console.error("Invalid data provided: Must be an array");
      return [];
    }

    return [
      {
        field: "region",
        headerName: "Region",
        minWidth: 125,
      },
      {
        field: "funderName",
        headerName: "Funder Name",
        minWidth: 125,
      },
      {
        field: "centerName",
        headerName: "Center Name",
        minWidth: 180,
      },
      {
        field: "projectCode",
        headerName: "Project Code",
        minWidth: 125,
      },
      {
        field: "state",
        headerName: "State",
        minWidth: 125,
      },
      {
        field: "district",
        headerName: "City",
        minWidth: 125,
      },
      {
        field: "cityManager",
        headerName: "City Manager",
        minWidth: 125,
      },
      {
        field: "centerStatus",
        headerName: "Center Status",
        minWidth: 125,
      },
      ...data.map((item, index) => ({
        field: item?.id || `field${index}`, // Fallback in case item.id is undefined
        headerName: item?.name || `Column ${index + 1}`,
        ...(data.length > 1 ? { minWidth: 200 } : { flex: 1 }),
        renderCell: (params: any) => {
          const value = params.value;
          return value ? value.toString() : "0";
        },
      })),
    ];
  };

  const ratiobtn = [
    { label: "East", value: "East" },
    { label: "West", value: "West" },
    { label: "North", value: "North" },
    { label: "South", value: "South" },
  ];

  const centerList = {
    centerSelect: centerListOptions?.centerSelect,
    regionalDirectorOptions: regionalDirector,
    cityManagerOptions: cityManager,
    stateOptions: indianStates,
    clusterManagerOptions: clusterManager,
    funderOptions: fetchedFunder,
    medals: medals,
    city: cities,
  };

  const handleFilterFormChange = (field: string, value: any) => {
    if (field == "region") {
      setFilter((prevFilter: any) => {
        return { region: prevFilter.region == value ? "" : value }; // Ensure you return the updated state
      });
      return
    }
    if (field === "state") {
      const indianCities: IndianCity[] = value?.id
        ? City.getCitiesOfState("IN", value?.id).map((city: any) => ({
            label: city.name,
            id: city.name,
          }))
        : [];
      setCities(indianCities);
    }
    setFilter((prevFilter: any) => ({
      ...prevFilter,
      [field]: value,
    }));
  };

  const totalPages = Math.ceil(targetTableData?.tableDataRowCount / 10);

  const tableData = Array.isArray(moduleData)
    ? moduleData?.map((item: any, tableIndex: number) => ({
        ...item,
        id: tableIndex + 1,
        name: item?.tabName || "-",
      }))
    : [];

  const handleSubTabsChange = (id: number) => {
    const selectedCategory = tableData?.find((category) => category?.id === id);
    if (selectedCategory) {
      setFinalData(selectedCategory);
    } else {
      console.log("Category not found for ID:", id);
    }
  };

  useEffect(() => {
    setIsApprovedDisabled(false);
    setParams({
      pageNo: "1",
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      programMasterId: selector?.selectedProgram?.value || undefined,
      programYearId: selector?.selectedYear?.value || undefined,
      quarterMasterId: selector?.selectedQuarter?.quarterMasterId || undefined,
    });

    handleUserData(masterData, finalData?.tabId);
  }, [location, selector, finalData?.tabId]);

  useEffect(() => {
    if (Array.isArray(moduleData) && moduleData.length > 1) {
      handleSubTabsChange(1);
      setFinalData(moduleData[0]); // Always setting index 0 when location updates
    } else {
      setFinalData(moduleData[0]); // Ensuring only one object is set
    }
  }, [location]);

  useEffect(() => {
    const permission = masterData[finalData?.tabId || ""];

    if (permission?.canRead || false) {
      setUserModuleAccess({
        canRead: permission.canRead || false,
        canWrite: permission.canWrite || false,
        canUpdate: permission.canUpdate || false,
        canDelete: permission.canDelete || false,
      });
    } else {
      console.log(`No read access for ${data}`);
    }
  }, [selector, masterData, finalData?.tabId]);

  useEffect(() => {
    setParams({
      pageNo: "1",
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      programMasterId: selector?.selectedProgram?.value || undefined,
      programYearId: selector?.selectedYear?.value || undefined,
      quarterMasterId: selector?.selectedQuarter?.quarterMasterId || undefined,
    });
  }, [selector]);

  return (
    <>
      <Stack>
        {moduleData?.length > 1 && (
          <Tabs tabs={tableData} handleTabChange={handleSubTabsChange} />
        )}

        <Header
          title={finalData?.tabName || "Operations HR data"}
          subTitle="Here you can view the targets given to the employees."
          buttons={userModuleAccess.canWrite ? magicPageHeaderBtn : []}
          chipLabel={`${
            isFetchingTargetTableData
              ? "0"
              : targetTableData?.tableDataRowCount || "0"
          } Target`}
        />

        <TableHeader
          buttons={magicTableHeaderBtn}
          searchTitle="Search by centre name"
          onSearchfieldChange={handleReportSearch}
        />

        <Table
          columns={coloumGenerator(finalData?.parameterFields)}
          rows={isFetchingTargetTableData ? [] : formattedData}
          loading={isFetchingTargetTableData}
          handlePageChange={handlePagination}
          count={isFetchingTargetTableData ? 1 : totalPages}
          rowCellsSx={{ paddingLeft: "16px", textAlign: "start" }}
          headerSx={{
            paddingLeft: "16px",
            textAlign: "start",
            fontWeight: 600,
            color: "#242424",
            padding: "13px 16px",
          }}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#DADADA",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 550,
              fontSize: "14px",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-cell": {
              display: "flex",
              alignItems: "center",
            },
          }}
          tableSx={{ minHeight: "350px", width: "100%" }}
          getRowId={(row: any) => row.id}
          currentPage={parseInt(params?.pageNo) || parseInt(currentPage) || 1}
        />

        <MagicDrawer
          title="Approve data"
          subtitle="Here you can approve the data by adding remark."
          drawerOpen={isOpenApproveData}
          onDrawerToggle={handleApproveDataBtnClick}
          actionComponent={() => (
            <>
              <Button
                className="bun-outline"
                onClick={handleApproveDataBtnClick}
                // disabled={isCreatingUser}
              >
                Cancel
              </Button>
              <Button
                className="bun-filled"
                onClick={handleEditFormSubmit(handleApproveDataDone)}
                // loading={isCreatingUser}
              >
                Approve
              </Button>
            </>
          )}
        >
          <ApproveDataFilter control={editFormControl} />
        </MagicDrawer>

        <MagicDrawer
          title="Add Filters"
          subtitle="See the data in an organized manner by applying filters"
          drawerOpen={isOpenFilterForm}
          onDrawerToggle={toggleFilerFormDrawer}
          actionComponent={() => (
            <>
              <Button
                className="bun-outline"
                onClick={handleClearAllFilterBtn}
                // disabled={isCreatingUser}
              >
                Clear All
              </Button>
              <Button
                className="bun-filled"
                onClick={handleApplyFilterBtn}
                // loading={isCreatingUser}
              >
                Apply
              </Button>
            </>
          )}
        >
          <TargetAchivmentfilterForm
            ratiobtn={ratiobtn}
            centerList={centerList}
            filter={filter}
            handleFilterFormChange={handleFilterFormChange}
          />
        </MagicDrawer>
      </Stack>
    </>
  );
};

export default TargetAchievementContainer;
